import React, {Component} from 'react'
import Button from "reactstrap/es/Button"
import BulkGenLabelModal from './BulkGenLabelModal'

class BulkGenLabel extends Component{
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        const {selectedItems, resetBulkAll, reloadItems} = this.props
        const {isOpen} = this.state

        if(!isOpen) {
            const r = window.confirm(`Are you sure want to do Gen label for ${selectedItems.length} ${selectedItems.length > 1 ? 'orders' : 'order'} selected?`)

            if (r !== true) {
                resetBulkAll()
                return
            }
        }

        this.setState({
            isOpen: !isOpen
        })

        if(isOpen) {
            resetBulkAll()
            reloadItems()
        }
    }

    render() {
        const {isOpen} = this.state

        return (
            <div>
                <Button color="link" onClick={this._handleToggleModal} className="mr-1">Gen label</Button>
                {isOpen && (
                    <BulkGenLabelModal
                        {...this.props}
                        isOpen={isOpen}
                        handleToggleModal={this._handleToggleModal}
                    />
                )}
            </div>
        );
    }

}

export default BulkGenLabel